import { render, staticRenderFns } from "./BigMenu.vue?vue&type=template&id=17b9eb9e&"
import script from "./BigMenu.vue?vue&type=script&lang=js&"
export * from "./BigMenu.vue?vue&type=script&lang=js&"
import style0 from "./BigMenu.vue?vue&type=style&index=0&id=17b9eb9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports